import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  useTheme
} from '@mui/material';
import MarketWatchExpandedRow from './MarketWatchExpandedRow';

const MarketWatchExpandedTable = ({ instruments, columns, watchListIndex, watchlists }) => {
  const theme = useTheme();

  return (
    <TableContainer 
      sx={{ 
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'transparent',
        // Webkit specific styling to override global index.css hiding
        '&::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
          display: 'block !important', // Necessary to override global index.css
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.2)',
          }
        },
        // Support for Firefox
        scrollbarWidth: 'thin !important',
        '& .MuiTableCell-root': {
          whiteSpace: 'nowrap',
          padding: '8px 10px',
          fontSize: '0.8125rem',
        },
        '& .MuiTableCell-head': {
          backgroundColor: theme.palette.background.paper,
          fontWeight: 700,
          borderBottom: `2px solid ${theme.palette.divider}`,
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }
      }}
    >
      <Table 
        stickyHeader 
        size="medium" 
        sx={{ 
          width: 'max-content', 
          minWidth: '100%',
          tableLayout: 'fixed' // Enforce predictable column widths
        }}
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell 
                key={column.field} 
                align={column.align || 'left'}
                style={{ width: column.width, minWidth: column.minWidth }}
              >
                {column.headerName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {instruments && instruments.length > 0 ? (
            instruments.map((instrument) => (
              <MarketWatchExpandedRow 
                key={instrument.token} 
                instrument={instrument} 
                columns={columns} 
                watchListIndex={watchListIndex}
                watchlists={watchlists}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} align="center" sx={{ py: 8 }}>
                No instruments in this watchlist.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MarketWatchExpandedTable;
